import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch, withRouter} from "react-router-dom";
import PersonalSchedulePage from "./PersonalSchedulePage";

function mapStateToProps(state) {
  return {};
}

class PersonalScheduleIndex extends Component {
  render() {
    return (
      <Switch>
        <Route component={PersonalSchedulePage} path="/personal-schedule"/>
      </Switch>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
)(PersonalScheduleIndex));
